import { usePostHogIdentify } from '../../hooks/usePostHogIdentify';

export default function PostHogIdentifier() {
    usePostHogIdentify();
    return null;
}
